import React, { useState, useEffect } from 'react';

import Login from './Components/Login';
import Navbar from './Components/Navbar';
import MainPage from './Components/MainPage';
import CustomerScopeForm from './Components/CustomerScopeForm';
import { BEAM_LOGO_URL } from './Components/CustomerScopeForm/BrandMark';
import { StyleProvider, Toast } from '@attentive-platform/stem-ui';
import { isBeamUser } from './Utils/HelperFunctions';

const isPublicScopeForm = () => window.location.pathname.startsWith('/scope-form/');

const ensureIconLink = () => {
  let link = document.querySelector("link[rel='icon']");
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'icon');
    document.head.appendChild(link);
  }
  return link;
};

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    try {
      const storedToken = localStorage.getItem('authToken');
      setIsLoggedIn(!!storedToken);
    } catch {
      // Site data blocked — treat as logged out.
      setIsLoggedIn(false);
    }
  }, []);

  useEffect(() => {
    if (!isPublicScopeForm()) return undefined;
    const previousTitle = document.title;
    document.title = 'Customer Scope Form';

    // Relative favicon href breaks under /scope-form/... — set Beam icon absolutely.
    const iconLink = ensureIconLink();
    const previousIcon = iconLink.getAttribute('href');
    const previousType = iconLink.getAttribute('type');
    iconLink.setAttribute('type', 'image/svg+xml');
    iconLink.setAttribute('href', BEAM_LOGO_URL);

    return () => {
      document.title = previousTitle;
      if (previousIcon != null) iconLink.setAttribute('href', previousIcon);
      if (previousType) iconLink.setAttribute('type', previousType);
      else iconLink.removeAttribute('type');
    };
  }, []);

  if (isPublicScopeForm()) {
    return (
      <div>
        <StyleProvider theme='default'>
          <Toast newestOnTop={false} limit={1} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          <CustomerScopeForm />
        </StyleProvider>
      </div>
    );
  }

  return (
    <div>
      <StyleProvider theme={isBeamUser() ? 'default' : 'attentive-internal'}>
        <Toast newestOnTop={false} limit={1} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        <Navbar isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />

        {!isLoggedIn ? <Login setIsLoggedIn={setIsLoggedIn} /> : <MainPage />}
      </StyleProvider>
    </div>
  );
}

export default App;
